<template>
  <div class="main-chapter1">
    <n-loader :loading="$var('load')" />
    <n-divide class="table-tools">
      <div></div>
      <n-link v-if="edit.records" :to="createRecordLink()"><n-button>Создать запись</n-button></n-link>
    </n-divide>

    <n-table :columns="columns" :data="data">
      <template #headerRow>
        <tr class="header">
          <td rowspan="2">Объём бетона, уложенного в дело (за смену)</td>
          <td rowspan="2">Температура наружного воздуха при бетонировании. Наличие атмосферных осадков</td>
          <td rowspan="2">Маркировка контрольных образцов бетона и их число. № акта об изготовлении контрольных образцов</td>
          <td rowspan="2">Подписи бригадира, сменных мастеров и лаборанта</td>
          <td colspan="2">Результаты испытания контрольных образцов</td>
          <td rowspan="2">Дата распалубливания</td>
          <td rowspan="2">Примечание</td>
          <td rowspan="2"></td>
        </tr>
        <tr class="header">
          <td>при распалубливании</td>
          <td>через 28 суток</td>
        </tr>
        <tr class="header">
          <td>1</td>
          <td>2</td>
          <td>3</td>
          <td>4</td>
          <td>5</td>
          <td>6</td>
          <td>7</td>
          <td>8</td>
          <td></td>
        </tr>
      </template>
      <template #signs="{item}">
        <c-journal-sign v-for="sign in item.signs" :sign="sign" />
      </template>
      <template #date="{item}">
        {{ $app.date.format(item.date) }} {{ item.shift }}
      </template>
      <template #tools="{item}">
        <n-link :to="showRecordLink(item.id)"><n-button icon="eye" /></n-link>
      </template>
    </n-table>

    <page-record-create v-if="newRecord" :project="project" :journal="journal" @reload="load" @close="$router.push(createRecordLink(false))" />
    <modal-record v-if="showRecord" :project="project" :journal="journal" @reload="load" @close="$router.push(showRecordLink(false))" />
  </div>
</template>

<script>
import PageRecordCreate from './CreateThree'
import ModalRecord from './record/record3'
import utils from 'utils'
import CJournalSign from "../../../components/journal/Sign";

export default {
  name: 'MainChapter4',
  components: {CJournalSign, ModalRecord, PageRecordCreate, },
  props: [ 'project', 'journal', ],
  data: () => ({
    utils,
    data: [
    ],
  }),
  computed: {
    newRecord() {
      return this.$route.query['new'] !== undefined
    },
    edit() {
      return {
        records: $app.auth.can('journals_spec2_records', this.project.id),
      }
    },
    showRecord() {
      return this.$route.query['show'] !== undefined
    },
    columns() {
      return [
        { name: 'volume', title: '', },
        { name: 'temperature', title: '', },
        { name: 'mark', title: '', },
        { name: 'signs', title: '', },
        { name: 'resultBefore', title: '', },
        { name: 'resultAfter', title: '', },
        { name: 'strippingDate', title: '', },
        { name: 'memo', title: '', },
        { name: 'tools', title: '', },
      ]
    },
  },
  watch: {
    project() {
      this.load()
    },
  },
  mounted() {
    this.load()
  },
  methods: {
    load() {
      this.$var('load', true)
      $api.journals.spec2.three.get(this.project.id)
        .query({
          'with[signs][with][author]': null,
          projectId: this.project.id,
        })
        .then((response) => {
          this.data = response.data.content
        }).finally(() => {
          this.$var('load', false)
        })
    },
    getUser(item, name) {
      if (!item[name]) {
        return ''
      }
      return item[name]?.participation?.position + ', ' + item[name]?.fullName
    },
    createRecordLink(open = true) {
      return { query: { ...this.$route.query, 'new': open ? null : undefined, }, }
    },
    showRecordLink(open) {
      return { query: { ...this.$route.query, 'show': open || undefined, }, }
    },
  },
}
</script>

<style lang="scss" scoped>
.main-chapter1 {

}
</style>
